import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Input from './item';

export class EmailInput extends Component {

  static propTypes = {
    value: PropTypes.string.isRequired,
    onChange : PropTypes.func.isRequired,
    showError: PropTypes.bool,
    showSuccess: PropTypes.bool,
    showOnChange: PropTypes.bool,
    showWarning: PropTypes.bool,
    showOnBlur: PropTypes.bool,
    onBlur: PropTypes.func,
    type: PropTypes.string,
    onCheck: PropTypes.func,
    disabled: PropTypes.bool
  };

  isValid(email) {
    // eslint-disable-next-line no-useless-escape
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@(?!ynov)((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    // → true
    return re.test(email);
  }

  render() {
    const error = (this.props.value.split("@").length === 2 && this.props.value.split("@")[1].indexOf("ynov") > -1 ? 
      "Les e-mails Ynov ne sont pas acceptés - veuillez utiliser le SSO d'Ynov" : 
      'Veuillez renseigner un e-mail valide');
      
    return (
      <Input
        icon="mail"
        placeholder= "Email"
        isValid={ this.isValid }
        status={ { success : '' , error } }
        { ...this.props }
        />
    );
  }
}

export default EmailInput;



// WEBPACK FOOTER //
// ./src/helper/form/input/email.js